import { Menu, MenuCategory, MenuSub } from '@/components/ui/typography/Typography';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function DesktopMenu({ menu, pathname }) {
  const hasSub = menu.subMenu && menu.subMenu.length > 0;
  const [open, setOpen] = useState(false);
  const isParentActive = pathname === menu.link || pathname.startsWith(menu.link + '/');

  // Jika submenu, cek apakah salah satu submenu memiliki link yg sama dgn pathname
  const isSubActive =
    hasSub &&
    menu.subMenu.some((col) =>
      col.items.some((item) => pathname === item.link || pathname.startsWith(item.link + '/'))
    );

  // Parent dianggap aktif jika langsung active atau salah satu submenu aktif
  const isActive = isParentActive || isSubActive;

  return (
    <li
      className={`group ${open ? 'open' : ''}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* ====== NO SUBMENU ====== */}
      {!hasSub && (
        <Link
          to={menu.link}
          className="px-4 py-4 flex items-center gap-1 transition-colors relative group"
        >
          {/* highlight underline */}
          <span className="relative inline-flex items-center">
            <span
              className={`absolute inset-0 mt-6
        h-[4px] bg-yellow-300 rounded-sm transition-all duration-300 -z-10 origin-left
        ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}
      `}
            />
            <Menu>{menu.name}</Menu>
          </span>
        </Link>
      )}

      {/* ====== WITH SUBMENU ====== */}
      {hasSub && (
        <button
          className={`px-4 py-4 flex items-center gap-1 transition-colors relative 
          `}
        >
          <span className="relative inline-flex items-center">
            <span
              className={`absolute inset-0 mt-6
        h-[4px] bg-yellow-300 rounded-sm transition-all duration-300 -z-10 origin-left
        ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}
      `}
            />
            <Menu>{menu.name}</Menu>
          </span>

          <ChevronDown
            size={16}
            className={`transition-transform duration-300 
              ${open ? 'rotate-180' : ''}
            `}
          />
        </button>
      )}

      {/* ====== DROPDOWN ====== */}
      {hasSub && (
        <div
          className={`absolute top-full left-1/2 -translate-x-1/2 
            w-[95vw] max-w-screen-2xl bg-white/95 shadow-xl py-10 
            z-50 rounded-xl border border-gray-300 -mt-3 text-primary
      
            transition-all duration-200
             ${open ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-2 invisible'}`}
        >
          <div className="w-10/12 max-w-screen-2xl mx-auto grid grid-cols-4 gap-5">
            {menu.subMenu.map((col, idx) => (
              <div
                key={idx}
                className={`space-y-3 ${idx !== 0 ? 'border-l border-gray-300 pl-6' : ''}`}
              >
                <MenuCategory>{col.title}</MenuCategory>
                <ul className="space-y-2">
                  {col.items.map((item, i) => {
                    const isItemActive = pathname === item.link;
                    return (
                      <li key={i}>
                        <Link
                          to={item.link}
                          onClick={() => setOpen(false)}
                          className={`relative inline-flex items-center transition-colors group/link
    ${isItemActive ? 'text-primary font-semibold' : 'text-gray-700 hover:text-primary'}
  `}
                        >
                          <span
                            className={`absolute inset-0 mt-3 bg-yellow-300 rounded-sm transition-all duration-300 -z-10 origin-left
      ${isItemActive ? 'scale-x-100' : 'scale-x-0 group-hover/link:scale-x-100'}
    `}
                          ></span>

                          <MenuSub>{item.name}</MenuSub>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </li>
  );
}
